export class ViveiroFactory {
  constructor(instance) {
    this.instance = instance;
  }

  acesso() {
    return this.instance.get('/v1/viveiro/acesso');
  }
}

export default (...params) => new ViveiroFactory(...params);
